import React, { useEffect, useState } from "react";
import { Hub } from "aws-amplify";
import toast from "react-hot-toast";
import { checkvalidateTenant, getTenantInfo, saveUserInTenantGroup, updateTenantFn } from "../Utility/ApiService";
import Placeholder from "react-bootstrap/Placeholder";
import { useNavigate } from "react-router-dom";
import { SpinnerLoading } from "../components/Loadings";
import randomstring from "randomstring";
import { LOGO } from "../Utility/static";
import { getMemberStatementId } from "../Utility";
import { clearLastAuthMethodIf, getAuthProvider } from "../Utility/lastAuthMethod";
export const Auth = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = Hub.listen("auth", (data) => {
      const signInSelected = localStorage.getItem("signInSelected");
      switch (data.payload.event) {
        case "cognitoHostedUI":
          if (signInSelected === "1") {
            onSocialSignup(data.payload.data);
          } else if (signInSelected === "0") {
            onSocialSignIn(data.payload.data);
          }
          break;
        default:
          break;
      }
    });

    return unsubscribe;
  }, []);

  const onSocialSignup = async (authUserdata) => {
    try {
      setLoading(true);
      const emailaddress = authUserdata?.signInUserSession?.idToken?.payload?.email;
      const poolId = authUserdata?.pool?.userPoolId;
      const username = authUserdata?.username;
      const parsedData = await getTenantInfo(emailaddress);
      const tenant = parsedData[0];
      if (!tenant) {
        return toast.error(
          "You need to sign-in with email address (or google/apple id) on which we sent you the invitation."
        );
      }

      await saveUserInTenantGroup(username, poolId);
      await updateTenantFn({
        id: tenant.id,
        first_name: authUserdata.signInUserSession.idToken.payload.given_name,
        last_name: authUserdata.signInUserSession.idToken.payload.name,
        email: authUserdata.signInUserSession.idToken.payload.email,
        cognito_user_id: authUserdata.signInUserSession.idToken.payload.sub,
        email_verification_uuid: randomstring.generate(20),
        email_verification: 1,
        active: 1,
      });
      setLoading(false);
      const memberStatementId = getMemberStatementId();
      navigate("/Dashboard", { state: { memberStatementId } });
    } catch (error) {
      setLoading(false);
      console.log("error saveUserInServer ", error);
      toast.error("Something went wrong");
    }
  };

  const onSocialSignIn = async (authUserdata) => {
    const provider = getAuthProvider(authUserdata);
    try {
      setLoading(true);
      const singInemail = authUserdata.signInUserSession?.idToken?.payload?.email;
      const parsedData = await getTenantInfo(singInemail);

      if (parsedData && parsedData[0] && !parsedData[0].cognito_user_id) {
        await updateTenantFn({
          id: parsedData[0]?.id,
          cognito_user_id: authUserdata.signInUserSession.idToken.payload.sub,
          first_name: authUserdata.signInUserSession.idToken.payload.given_name,
          last_name: authUserdata.signInUserSession.idToken.payload.name,
          email: authUserdata.signInUserSession.idToken.payload.email,
          email_verification_uuid: randomstring.generate(20),
          email_verification: 1,
        });
      }

      const dd = await checkvalidateTenant({ email: singInemail });
      if (dd.status !== 200) {
        if (dd.status === 404) {
          toast.error("Invalid Tenant Credentials");
        } else {
          toast.error(`We are unable to log you in at this time, please contact your landlord/property manager.`);
        }
        clearLastAuthMethodIf(provider); // don't keep steering the tenant to a method the backend just rejected
        setTimeout(() => {
          Auth.signOut();
        }, [2000]);
      } else {
        const memberStatementId = getMemberStatementId();
        navigate("/Dashboard", { state: { memberStatementId } });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error signin", error);
      clearLastAuthMethodIf(provider); // e.g. unlinked Sign in with Apple (Hide My Email) rejected by the identity gate
      toast.error("Something went wrong while signing in");
    }
  };

  return (
    <div className="forms">
      <div id="layout-wrapper">
        {loading && (
          <div className="loadingSpinner">
            <SpinnerLoading />
          </div>
        )}

        <div className="errors"></div>
        {/* START SignIn / SignUp */}
        <div className="form-pages">
          <section className="sidebar align-items-center">
            <img src={LOGO} alt="" className="logo-img" />
          </section>
          {/* end sidebar */}
          <section className="content align-items-center justify-content-center">
            <div className="auth-form bg-white" style={{ color: "rgb(223 223 223)" }}>
              <div className="d-flex">
                <Placeholder
                  xs={1}
                  style={{
                    borderRadius: "8px",
                    height: "24px",
                    width: "24px",
                  }}
                />
                <Placeholder xs={3} className="ms-3 rounded " />
              </div>
              <div className="mt-5">
                <Placeholder xs={1} size="md" className="rounded " />
                <Placeholder xs={12} className="mt-1 social-placeholder-lg" />
              </div>

              <div className="mt-4">
                <Placeholder xs={2} size="md" className="rounded" />
                <Placeholder xs={12} className="mt-1 social-placeholder-lg" />
                <div className="d-flex flex-row-reverse mt-2">
                  <Placeholder xs={4} size="md" className="rounded" />
                </div>
              </div>
              <div className="mt-5">
                <Placeholder xs={12} className=" social-placeholder-lg" />
                <div className="mt-2 d-flex justify-content-center">
                  <Placeholder xs={6} size="md" className="rounded" />
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};
